import * as Yup from 'yup';

export const getPricingGroupValidationSchema = (globalT: (key: string) => string, t: (key: string) => string) => {
    return Yup.object().shape({
        name: Yup.string().min(1).matches(/\S/, globalT('InvalidTemplate')).required(globalT('errorRequired')),
        startPrice: Yup.number().positive(globalT('errorNumber')).required(globalT('errorRequired')),
        endPrice: Yup.number()
            .positive(globalT('errorNumber'))
            .required(globalT('errorRequired'))
            .when('startPrice', {
                is: (startPrice: number) => startPrice > 0,
                then: (schema) => schema.min(Yup.ref('startPrice'), t('endPriceMustBeGreaterThanStartPrice'))
            }),
    });
};

